import React from 'react';
import { styled, css } from 'styled-components';

const Message = styled.span<{ $warning: boolean; $error: boolean }>`
  ${({ theme }) => theme.typography.textMedium}
  margin-top: 4px;
  display: inline-flex;
  ${({ $error, theme }) =>
    $error &&
    css`
      color: ${theme.colors.critical100};
    `}
  ${({ $warning, theme }) =>
    $warning &&
    css`
      color: ${theme.colors.warning100};
    `}
`;

interface IAdditionalMessage {
  message: string;
  error?: boolean;
}

const AdditionalMessage: React.FC<IAdditionalMessage> = ({ message, error }) => (
  <Message data-testid='warning-message' $warning={!error} $error={!!error}>
    {message}
  </Message>
);

export default React.memo(AdditionalMessage);
